import { FC } from 'react'
import { useField } from 'react-final-form'

import TextArea from '../molecules/TextArea'

type Props = {
  isConfirm: boolean
  label?: string
  required?: boolean
  placeholder?: string
}

const NAME = 'availableLanguages'

const AvailableLanguagesField: FC<Props> = ({
  isConfirm,
  label = '使用可能言語',
  required = false,
  placeholder = 'あなたの使用可能なプログラム言語を記入してください\n■記入例\nTypescript 習得2年\nPython 習得1年\nPHP 実務5年',
}) => {
  const {
    input: { value },
  } = useField(NAME)

  if (isConfirm && !value) return null

  return (
    <TextArea
      label={label}
      name='availableLanguages'
      isConfirm={isConfirm}
      required={required}
      placeholder={placeholder}
      helperText='使用されている年数を実務・習得に分けてご記入ください'
    />
  )
}

AvailableLanguagesField.displayName = 'availableLanguages'

export default AvailableLanguagesField
